import { screensLocationSharedOptions } from './screensLocationSharedOptions';
import { ScreenOptions } from '../../../shared/pages/interfaces/ScreenOptions';

export const screensLocationInUseOptions: Partial<ScreenOptions> = screensLocationSharedOptions;
